<template>
  <div class="p-3 container">
    <el-card v-if="isOrder">
      <div slot="header" class="font-weight-bold text-left d-flex justify-content-between">
        {{ $tc('general.delivery_address', 1) }}
        <el-link type="primary" @click="onAddDeliveryAddress">
          {{ $t('general.add') }}
        </el-link>
      </div>

      <div>
        <el-select v-model="cd.deliveryAddress" class="w-100" :placeholder="$t('placeholder.select_delivery_address')">
          <el-option
            v-for="a in deliveryAddresses"
            :key="a.id"
            :value="a.id"
            :label="`${a.get('company')} | ${a.get('street')}, ${a.get('zipCode')} ${a.get('city')}`"
          />
        </el-select>
      </div>
    </el-card>
    <el-card class="mt-3">
      <div slot="header" class="font-weight-bold text-left">
        {{ $t('general.general') }}
      </div>
      <div class="text-left">
        <div v-if="isOrder">
          <label>{{ $t('placeholder.contact_at_location') }}</label>
          <el-input v-model="cd.contactAtLocation" class="w-100" />
        </div>
        <div v-if="isOrder" class="mt-3">
          <label>{{ $t('placeholder.phone') }}</label>
          <el-input v-model="cd.phone" class="w-100" />
        </div>
        <div>
          <label class="mt-3">{{ $t('placeholder.project') }}</label>
          <el-input v-model="cd.project" class="w-100" />
        </div>
        <div v-if="isOrder">
          <label class="mt-3">{{ $t('checkout.adjoining_area') }}</label>
          <el-switch
            v-model="cd.adjoiningArea"
            :active-text="$t('general.yes')"
            :inactive-text="$t('general.no')"
            class="d-block"
          />
          <div v-if="cd.adjoiningArea">
            <label class="mt-3">{{ $t('checkout.reference_id') }}</label>
            <el-input v-model="cd.referenceId" class="w-100" />
          </div>
        </div>
        <div v-if="isOrder && !isEnglish">
          <label class="mt-3">{{ $t('checkout.lkw_ramp') }}</label>
          <el-switch
            v-model="cd.lkw"
            :active-text="$t('general.yes')"
            :inactive-text="$t('general.no')"
            class="d-block"
          />
        </div>
        <div v-if="isOrder">
          <label class="mt-3">{{ $t('checkout.delivery_date') }}</label>
          <el-date-picker
            v-model="cd.deliveryDate"
            class="w-100"
            type="date"
            format="dd.MM.yyyy"
            :picker-options="pickerOptions"
            :editable="false"
          />
        </div>
        <div v-if="isOrder && isEnglish">
          <div>
            <label class="mt-3">FCA (transport organised by Customer)</label>
            <el-switch
              v-model="cd.termsOfDelivery.fca"
              :active-text="$t('general.yes')"
              :inactive-text="$t('general.no')"
              class="d-block"
            />
          </div>
          <div>
            <div>
              <label class="mt-3">CIP *</label>
              <el-switch
                v-model="cd.termsOfDelivery.cip"
                :active-text="$t('general.yes')"
                :inactive-text="$t('general.no')"
                class="d-block"
              />
            </div>
            <div v-if="cd.termsOfDelivery.cip">
              <label class="mt-3">Unloading equipment required(for CIP only)</label>
              <el-switch
                v-model="cd.termsOfDelivery.unloadingEquipment"
                :active-text="$t('general.yes')"
                :inactive-text="$t('general.no')"
                class="d-block"
              />
            </div>
          </div>
          <div>
            <label class="mt-3">CIF **</label>
            <el-switch
              v-model="cd.termsOfDelivery.cif"
              :active-text="$t('general.yes')"
              :inactive-text="$t('general.no')"
              class="d-block"
            />
          </div>
          <div class="small pt-3">
            (*/** transport organised by VIACOR)
          </div>
          <div>
            <label class="mt-3">Documents required</label>
            <el-input v-model="cd.documentsRequired" type="textarea" />
          </div>
        </div>
      </div>
    </el-card>
    <el-card class="mt-3">
      <div slot="header" class="font-weight-bold text-left">
        {{ $t('general.notes') }}
      </div>
      <div>
        <el-input v-model="cd.notes" type="textarea" />
      </div>
    </el-card>
    <el-card v-if="isOrder && isEnglish" class="text-left mt-3 font-weight-bold py-1">
      Please note that we will have to charge a lump sum in the amount of € 50.00 for each change of order.
    </el-card>
    <el-button type="primary" class="my-4 w-100 shadow" @click="onNext">
      {{ $t('general.next') }}
    </el-button>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import StoreModules from '../../store/store-modules';
import AddDeliveryAddressModal from '../../components/modals/AddDeliveryAddressModal';
export default {
  name: 'CheckoutDetailsPage',
  components: {},
  props: {},
  mounted() {
    if (!this.checkoutType) {
      this.$router.push({ name: this.$routeNames.CHECKOUT_TYPE_PAGE_ROUTE });
    }
    this.cd = this.checkoutDetails;
    this.loadAddresses();
  },
  destroyed() {},
  data() {
    return {
      cd: {
        deliveryAddress: null,
        deliveryDate: null,
        contactAtLocation: '',
        project: '',
        notes: '',
        lkw: false,
        phone: '',
        adjoiningArea: false,
        documentsRequired: '',
        referenceId: '',
        termsOfDelivery: {
          fca: false,
          cip: false,
          cif: false,
          unloadingEquipment: false,
        },
      },

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now();
        },
      },
    };
  },
  computed: {
    ...mapGetters(StoreModules.USER, ['currentUser', 'language']),
    ...mapGetters(StoreModules.DELIVERY_ADDRESSES, ['deliveryAddresses']),
    ...mapGetters(StoreModules.CHECKOUT, ['checkoutType', 'checkoutDetails']),
    isOrder() {
      return this.checkoutType === 'Order';
    },
    isEnglish() {
      return this.language === 'en';
    },
  },
  methods: {
    ...mapActions(StoreModules.DELIVERY_ADDRESSES, ['loadAddresses']),
    ...mapMutations(StoreModules.CHECKOUT, ['setCheckoutDetails']),
    onAddDeliveryAddress() {
      this.$modal.show(AddDeliveryAddressModal, {}, { height: 'auto', width: '90%' });
    },
    onNext() {
      if (this.validateInputs()) {
        this.setCheckoutDetails(this.cd);
        this.$router.push({ name: this.$routeNames.CHECKOUT_SUMMARY_PAGE_ROUTE });
      }
    },
    validateInputs() {
      if (!this.cd.deliveryAddress && this.isOrder) {
        this.$message.error(this.$t('messages.fill_out_item', { field: this.$tc('general.delivery_address', 1) }));
        return false;
      }

      if (!this.cd.contactAtLocation && this.isOrder) {
        this.$message.error(this.$t('messages.fill_out_item', { field: this.$t('placeholder.contact_at_location') }));
        return false;
      }

      if (!this.cd.project) {
        this.$message.error(this.$t('messages.fill_out_item', { field: this.$t('placeholder.project') }));
        return false;
      }

      if (!this.cd.deliveryDate && this.isOrder) {
        this.$message.error(this.$t('messages.fill_out_item', { field: this.$t('checkout.delivery_date') }));
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped></style>
